import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { KEYCLOAK_JSON, WEB_ENDPOINT } from '../utils/env';

// keycloak-js 3.4.3 is a UMD module, Vite handles CJS→ESM conversion
import Keycloak from 'keycloak-js';

@Injectable({ providedIn: 'root' })
export class KeycloakService {
  static auth: any = {};
  static logoutFuncs: any[] = [];
  static updateRefreshTokenFunc: any;
  static i18nAcceptLanguageHeader: string;

  static init(token?: string, refreshToken?: string, idToken?: string): Observable<any> {
    const keycloakAuth: any = new (Keycloak as any)(KEYCLOAK_JSON);
    KeycloakService.auth.loggedIn = false;
    let initParams: any;
    if (!token) {
      initParams = {
        onLoad: 'login-required',
      };
    } else {
      initParams = {
        checkLoginIframe: false,
        token: token,
        refreshToken: refreshToken,
        idToken: idToken,
      };
    }

    return new Observable((subscriber: Subscriber<any>) => {
      keycloakAuth
        .init(initParams)
        .success(() => {
          KeycloakService.auth.loggedIn = true;
          KeycloakService.auth.authz = keycloakAuth;
          subscriber.next(true);
          subscriber.complete();
        })
        .error(() => {
          subscriber.error(null);
        });
    });
  }

  public static registerUpdateRefreshTokenFunc(func: any) {
    KeycloakService.updateRefreshTokenFunc = func;
  }

  /**
   * Refresh the Keycloak token. Returns a Promise<string> with the new token.
   */
  public static updateToken(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      KeycloakService.auth.authz
        .updateToken(30)
        .success(() => {
          resolve(KeycloakService.auth.authz.token as string);
        })
        .error(() => {
          if (KeycloakService.updateRefreshTokenFunc) {
            KeycloakService.updateRefreshTokenFunc().subscribe(
              (x: any) => resolve(x),
              (_error: any) => {
                console.error('unable to refresh token with registered func');
                KeycloakService.logout();
                reject(false);
              },
            );
          } else {
            console.error('unable to refresh token');
            KeycloakService.logout();
            reject(false);
          }
        });
    });
  }

  public static registerLogoutFunc(func: any) {
    KeycloakService.logoutFuncs.push(func);
  }

  public static logout() {
    // cleanup before redirect
    for (const func of KeycloakService.logoutFuncs) {
      func();
    }
    // Use the build-time WEB_ENDPOINT constant. `window.__WL_CONFIG__` was never
    // a real runtime global: Vite's `define` only substitutes the bare
    // `__WL_CONFIG__` identifier (as in env.ts), not property accesses like
    // `window.__WL_CONFIG__`, so the latter stayed undefined in the bundle and
    // threw "Cannot read properties of undefined (reading 'WEB_ENDPOINT')".
    window.location.href = KeycloakService.auth.authz.createLogoutUrl({
      redirectUri: WEB_ENDPOINT,
    });
  }
}
